import { gql, TypedDocumentNode } from '@apollo/client';
import { CART_FRAGMENT, CartVersion, Cart } from '../cart.rest';

export enum LegacyCartUpdateAction {
  UpdateCart = 'update_cart'
}

export enum LegacyCartUpdatePropertyName {
  PaymentSource = 'payment_source',
  RenderedBy = 'rendered_by',
  CountryCode = 'country_code',
  Phone = 'phone',
  AddressLine1 = 'address_line1',
  AddressLine2 = 'address_line2',
  FirstName = 'first_name',
  LastName = 'last_name',
  Default = 'default',
  State = 'state',
  City = 'city',
  PostalCode = 'postal_code',
  ShippingMethod = 'shipping_packaging'
}

type RestUserCartsAttributes = {
  state: string | undefined;
  city: string | undefined;
  phone: string;
  postal_code: string | undefined;
  country_code: string | undefined;
  address_line1: string;
  address_line2: string;
  first_name: string;
  last_name: string;
  default: boolean;
};

export type LegacyUpdateCartMutationAttributes = Partial<{
  id: string;
  address: RestUserCartsAttributes;
  [LegacyCartUpdatePropertyName.PaymentSource]: string;
  [LegacyCartUpdatePropertyName.RenderedBy]: string | null;
  [LegacyCartUpdatePropertyName.CountryCode]: string | null;
  [LegacyCartUpdatePropertyName.AddressLine1]: string;
  [LegacyCartUpdatePropertyName.AddressLine2]: string;
  [LegacyCartUpdatePropertyName.FirstName]: string;
  [LegacyCartUpdatePropertyName.LastName]: string;
  [LegacyCartUpdatePropertyName.Default]: boolean;
  [LegacyCartUpdatePropertyName.Phone]: string;
  [LegacyCartUpdatePropertyName.State]: string | null;
  [LegacyCartUpdatePropertyName.City]: string | null;
  [LegacyCartUpdatePropertyName.PostalCode]: string | null;
  [LegacyCartUpdatePropertyName.ShippingMethod]: number;
}>;

type LegacyUpdateCartMutationVariablesInputData = {
  action_type: LegacyCartUpdateAction;
  attributes: LegacyUpdateCartMutationAttributes;
  id: string;
  type: 'carts';
};

type LegacyUpdateCartMutationVariablesInput = {
  data: LegacyUpdateCartMutationVariablesInputData;
};

export type LegacyUpdateCartMutation = {
  legacyUpdateCart: {
    data: Cart[];
  };
};

export type LegacyUpdateCartMutationVariables = {
  id: string;
  countryCode: string;
  target: CartVersion;
  input: LegacyUpdateCartMutationVariablesInput;
};

export const LEGACY_UPDATE_CART_MUTATION: TypedDocumentNode<
  LegacyUpdateCartMutation,
  LegacyUpdateCartMutationVariables
> = gql`
  mutation LegacyUpdateCartMutation(
    $id: String!
    $countryCode: String!
    $target: String!
    $input: LegacyUpdateCartMutationVariablesInput!
  ) {
    legacyUpdateCart(id: $id, input: $input)
      @rest(
        type: "RestUserCart"
        endpoint: "cart"
        path: "/v3.3/carts/{args.id}"
        method: "PATCH"
      ) {
      data @type(name: "RestUserCartData") {
        ...CartFragment
      }
    }
  }
  ${CART_FRAGMENT}
`;
